<dx-data-grid
  [dataSource]="avoirExterneSvc.avoirExterneResource.value() ?? []"
  keyExpr="id"
  class="data-grid"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  columnResizingMode="widget"
  (onOptionChanged)="onGridOptionChanged($event)"
  (onEditorPreparing)="onEditorPreparing($event)"
  (onSelectionChanged)="onSelectionChanged($event)">

  <dxo-load-panel [enabled]="avoirExterneSvc.avoirExterneResource.isLoading()"></dxo-load-panel>

  <dxo-toolbar>
    @if (hasExportCegid) {
      <dxi-item location="before" template="periodeReceptionTemplate"></dxi-item>
      <dxi-item location="after" template="exportCegidTemplate"></dxi-item>
    }
  </dxo-toolbar>

  <div *dxTemplate="let _ of 'exportCegidTemplate'">
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT_INNER"
      iconClass="fas fa-file-export"
      tooltip="Exporter factures et avoirs en .tra (Cegid)"
      label="Export Cegid .tra"
      (onClick)="exportCegid()">
    </yo-button>
  </div>

  <div *dxTemplate="let _ of 'periodeReceptionTemplate'">
    <yo-date-range-box
      [selectedDates]="dateReceptionSelectedDates"
      startDateLabel="Réception du"
      endDateLabel="au"
      (onValueChange)="onDateReceptionChange($event)">
    </yo-date-range-box>
  </div>

  <dxo-group-panel [visible]="true" emptyPanelText="Glisser une colonne ici pour regrouper"></dxo-group-panel>
  <dxo-grouping [autoExpandAll]="true"></dxo-grouping>

  <dxi-column
    dataField="id"
    caption="Actions"
    cssClass="text-align-center vertical-align-middle"
    width="70"
    [allowFiltering]="false"
    [allowHeaderFiltering]="false"
    [allowSorting]="false"
    [allowGrouping]="false"
    cellTemplate="actionsCellTemplate">
  </dxi-column>

  <dxi-column
    dataField="numero"
    caption="Numéro"
    [allowFiltering]="true"
    [allowHeaderFiltering]="false">
  </dxi-column>

  <dxi-column
    dataField="siteExterneLibelle"
    caption="Site"
    [allowFiltering]="true"
    [allowHeaderFiltering]="false">
  </dxi-column>

  <dxi-column
    dataField="avoirNumeroRecherche"
    caption="N° Avoir(s) fournisseur"
    [calculateCellValue]="getAvoirNumeroJoined"
    [allowFiltering]="true"
    [allowHeaderFiltering]="false"
    [allowGrouping]="false"
    [allowSorting]="false"
    cellTemplate="avoirNumeroCellTemplate">
  </dxi-column>

  <dxi-column
    dataField="statut"
    caption="Statut"
    [allowFiltering]="true"
    [allowHeaderFiltering]="false"
    [calculateDisplayValue]="getStatutLabel">
  </dxi-column>

  <dxi-column
    dataField="dateFacture"
    caption="Date"
    dataType="date"
    [allowFiltering]="true"
    [allowHeaderFiltering]="false">
  </dxi-column>

  <dxi-column
    dataField="rapprochementStatut"
    caption="Statut rapprochement"
    width="170"
    [allowFiltering]="true"
    [allowHeaderFiltering]="false"
    [calculateDisplayValue]="getRapprochementStatutLabel">
  </dxi-column>

  <dxi-column
    dataField="dateRapprochement"
    caption="Date rapprochement"
    dataType="date"
    [allowFiltering]="true"
    [allowHeaderFiltering]="false">
  </dxi-column>

  <dxi-column
    dataField="factureBloquante"
    caption="Facture bloquante"
    dataType="boolean"
    [allowFiltering]="true"
    [allowHeaderFiltering]="false">
  </dxi-column>

  <dxi-column
    dataField="montantHT"
    caption="Montant HT"
    dataType="number"
    [allowFiltering]="false"
    [allowHeaderFiltering]="false"
    [allowGrouping]="false"
    cellTemplate="montantHTCellTemplate">
  </dxi-column>

  <dxi-column
    dataField="montantTTC"
    caption="Montant TTC"
    dataType="number"
    [allowFiltering]="false"
    [allowHeaderFiltering]="false"
    [allowGrouping]="false"
    cellTemplate="montantTTCCellTemplate">
  </dxi-column>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button size="small" [theme]="ButtonThemeEnum.DEFAULT_INNER"
      iconClass="fas fa-eye"
      tooltip="Voir l'avoir externe"
      (onClick)="openDialog(cell.row.data)">
    </yo-button>
    @if (cell.row.data.statut === AvoirExterneStatutEnum.A_TRAITER && cell.row.data.rapprochementStatut === RapprochementAvoirExterneStatutEnum.BL_MANQUANT) {
      <yo-button
        size="small"
        iconClass='fa fa-plus'
        [theme]="ButtonThemeEnum.SECONDARY_INNER"
        [tooltip]="'Rapprocher manuellement l\'avoir'"
        (onClick)="openRapprochementDialog(cell.row.data)">
      </yo-button>
    }
  </div>

  <div *dxTemplate="let cell of 'avoirNumeroCellTemplate'">
    @for (numero of getAvoirNumeroList(cell.row.data); track numero) {
      <div>{{ numero }}</div>
    }
  </div>

  <div *dxTemplate="let cell of 'montantHTCellTemplate'">
    {{ cell.value | number:'1.2-2' }} €
  </div>

  <div *dxTemplate="let cell of 'montantTTCCellTemplate'">
    {{ cell.value | number:'1.2-2' }} €
  </div>

  <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-header-filter [visible]="false"></dxo-header-filter>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-paging [pageSize]="20"></dxo-paging>
  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} avoir(s) externe(s)">
  </dxo-pager>
</dx-data-grid>

<yo-avoir-externe-dialog
  [(displayDialog)]="showDialog"
  [avoirId]="selectedAvoirId()"
  [dialogTitle]="selectedDialogTitle()">
</yo-avoir-externe-dialog>

<yo-rapprochement-avoir-externe
  [(displayDialog)]="showRapprochementDialog"
  [avoirExterneId]="selectedAvoirIdForRapprochement()"
  [avoirExterneNumero]="selectedAvoirNumeroForRapprochement()">
</yo-rapprochement-avoir-externe>

<yo-cegid-export-errors-dialog
  [(displayDialog)]="showCegidErrorsDialog"
  [errorList]="cegidErrorList()">
</yo-cegid-export-errors-dialog>
